import apiVersion from '../_helpers/api-version';
import axiosInstance from '../_helpers/axiosConfig'

import { authHeader } from '../_helpers/auth-header';
import httpStatus from 'http-status';

export const authenticationService = {
  login,
  logout,
  refresh,
}

function refresh(providerId, token) {
  return axiosInstance.request({
    url: `${process.env.REACT_APP_API_URL}/${apiVersion()}/client/provider/${providerId}/authentication`,
    headers: { 'Authorization': `Bearer ${token}` },
    method: 'GET',
  })
  .then(response => {
    if (response && response.status === httpStatus.OK) {
      return response.data
    }
  });
}

function login(providerId, username, password) {
  return axiosInstance.request({
    method: 'POST',
    url: `${process.env.REACT_APP_API_URL}/${apiVersion()}/client/authentication`,
    data: {
      username: username,
      password: password,
      providerId: providerId,
      grant_type: "password",
      client_id: process.env.REACT_APP_CLIENT_ID,
      client_secret: process.env.REACT_APP_CLIENT_SECRET
    }
  })
    .then(response => {
      return response.data
    });
}

function logout() {
  return axiosInstance.request({
    method: 'DELETE',
    headers: authHeader(),
    url: `${process.env.REACT_APP_API_URL}/${apiVersion()}/client/authentication`,
  });
}